import React, { Component } from 'react';
import SystemResource from '../resources/System';
import HeaderButtons from '../components/HeaderButtons';
import { withIonLifeCycle } from '@ionic/react';
import moment from 'moment';
import { IonHeader, IonToolbar, IonBackButton, IonContent, IonTitle, IonButtons, IonItem, IonText } from '@ionic/react';

import Calendar from '../components/Calendar';
import ReservationsService from '../services/reservations';
class ReservationPage extends Component {
  constructor(props) {
    super(props);

    this.loader = React.createRef();

    this.state = {
      momentDate: moment(),
      service: [],
    };
  }

  async ionViewWillEnter() {
    if (!!this.props.loader) this.props.loader.current.show();

    try {
      const { id } = this.props.match.params;
      const response = await ReservationsService.findOne({ id });
      const { service } = response.data;
      this.setState({ service });
      SystemResource.checkVersion();
    } catch (error) {
      console.error(error);
    } finally {
      this.props.loader.current.dismiss();
    }
  }

  render() {
    const { momentDate, service } = this.state;

    const handleNextMonth = () => {
      let momentClone = momentDate.clone().add(1, 'M');

      if (momentClone.format('YYMM') <= moment().add(12, 'M').format('YYMM')) {
        this.setState({ momentDate: momentDate.add(1, 'M') });
      }
    };

    // Il calendario si apre sul mese del giorno da preselezionare (link del chatbot).
    const goToMonth = (month) => {
      this.setState({ momentDate: month.clone().startOf('month') });
    };

    const handlePrevMonth = () => {
      let momentClone = momentDate.clone().subtract(1, 'M');

      if (momentClone.format('YYMM') >= moment().format('YYMM')) {
        this.setState({ momentDate: momentDate.subtract(1, 'M') });
      }
    };

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/services" />
            </IonButtons>
            <HeaderButtons {...this.props} />
            <IonTitle>Prenotazione </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonItem>
            <p>{service.name}</p>
          </IonItem>
          {!!service.image_url && (
            <div className="ion-text-center">
              <img
                src={service.image_url}
                alt={service.name}
                style={{
                  width: '100%',
                  height: '250px',
                  objectFit: 'cover',
                }}
              />
            </div>
          )}
          <div className="ion-padding" dangerouslySetInnerHTML={{ __html: service.description }} />

          {/*
            Servizio con dispositivo collegato: la prenotazione include sempre il
            noleggio, non è opzionale. Il cliente deve saperlo prima di scegliere
            data e ora, perché gli slot mostrati tengono già conto della
            disponibilità del dispositivo.
          */}
          {!!service.rental_device && (
            <IonItem lines="none" color="light">
              <IonText className="ion-text-wrap">
                <p className="ion-no-margin">
                  <strong>La prenotazione include il noleggio</strong> di {service.rental_device.name} per{' '}
                  {service.rental_days} {Number(service.rental_days) === 1 ? 'giorno' : 'giorni'}.
                </p>
              </IonText>
            </IonItem>
          )}

          <Calendar
            momentDate={momentDate}
            serviceId={this.props.match.params.id}
            nextMonth={handleNextMonth}
            prevMonth={handlePrevMonth}
            goToMonth={goToMonth}
            {...this.props}
          />
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(ReservationPage);
